import requestAction from '../../utils/requestAction'

export const fetchGoals = (params: string, handleResponse?: (response: any) => void) =>
  requestAction('GOAL_LIST', params)(`goals`, 'GET',
    undefined,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response) })
